var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('span',[_vm._v(_vm._s(_vm.subscriber.name))])]),_c('td',[_c('span',[_vm._v(_vm._s(_vm.subscriber.email))])]),_c('td',[_c('span',[_vm._v(_vm._s(_vm.subscriber.status))])]),_c('td',[_c('span',[_vm._v(_vm._s(_vm.moment(_vm.subscriber.inserted_at).format('DD.MM.YYYY.')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }